import { Routes } from "@angular/router";

export const CAREERS_ROUTES: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("./pages/careers/careers.component").then(
        (m) => m.CareersComponent,
      ),
  },
];
